import React from 'react';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { Search } from 'lucide-react';
import { useIntl } from 'react-intl';
import { portalColors, portalInput } from '../portal-styles';

export default function PortalSearch({ options, onSelect, loading = false, id = 'portal-catalog-search', label, autoFocus = false, prominent = false }) {
  const intl = useIntl();

  return <Box>
    <Typography component="label" htmlFor={id} sx={{ display: 'block', mb: 1.25, fontSize: 14, fontWeight: 500, color: portalColors.ink }}>
      {label || intl.formatMessage({ id: 'portal.search.label' })}
    </Typography>
    <Autocomplete id={id} value={null} options={options}
      groupBy={option => option.organizationname}
      getOptionLabel={option => `${option.path} ${option.organizationname}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(_, value) => value && onSelect(value)} loading={loading}
      loadingText={intl.formatMessage({ id: 'portal.search.loading' })}
      autoHighlight clearOnEscape noOptionsText={intl.formatMessage({ id: 'portal.search.no.results' })}
      componentsProps={{ paper: { sx: { mt: 1, borderRadius: '16px', boxShadow: '0 12px 36px rgba(0,0,0,0.12)',
        '& .MuiAutocomplete-groupLabel': { color: portalColors.muted, bgcolor: portalColors.paper, fontWeight: 500, lineHeight: '40px' } } } }}
      ListboxProps={{ sx: { p: 1, '& .MuiAutocomplete-option': { borderRadius: '10px', mx: 0.5 },
        '& .MuiAutocomplete-option.Mui-focused, & .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
          bgcolor: `${portalColors.soft} !important`,
        },
      } }}
      renderOption={(props, option) => <Box component="li" {...props} key={`${option.organizationid}-${option.id}`}
        sx={{ py: '12px !important', display: 'flex', flexDirection: 'column', alignItems: 'flex-start !important', gap: 0.5 }}>
        <Typography sx={{ fontWeight: 500, lineHeight: 1.4, overflowWrap: 'anywhere', color: portalColors.ink }}>{option.name}</Typography>
        {option.path !== option.name && <Typography variant="body2" sx={{ color: portalColors.muted, overflowWrap: 'anywhere' }}>{option.path}</Typography>}
      </Box>}
      renderInput={params => <TextField {...params} autoFocus={autoFocus}
        placeholder={intl.formatMessage({ id: 'portal.search.placeholder' })}
        InputProps={{ ...params.InputProps,
          startAdornment: <><Box component="span" sx={{ display: 'flex', mx: 1, color: portalColors.action }}><Search size={22} strokeWidth={1.6} aria-hidden="true" /></Box>{params.InputProps.startAdornment}</>,
        }} fullWidth sx={{ ...portalInput,
          '& .MuiOutlinedInput-root': { ...portalInput['& .MuiOutlinedInput-root'], minHeight: prominent ? 64 : 56,
            boxShadow: prominent ? '0 4px 16px rgba(0,0,0,0.04)' : 'none' },
        }} />}
    />
  </Box>;
}
